// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>24</span>&nbsp;&nbsp;Awake, arise, to my cause,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;to my defence, my God and my Lord!<br> </p> </div></div>";
// Exports
module.exports = code;